import { render } from "./genericGate.vue?vue&type=template&id=26ea2123"
import script from "./genericGate.vue?vue&type=script&lang=js"
export * from "./genericGate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__